<article class="history">
	@if (allEntries$ | async; as allEntries) {
		<ul class="list">
			@if (allEntries | visibleFilter: isCollapsed; as visibleEntries) {
				@for (entry of $any(visibleEntries); track entry; let i = $index; let last = $last) {
					<li class="list-item">
						<div class="label">
							<div class="avatar-cell">
								<stages-user-image
									[userName]="entry.user.name"
									userId="{{ entry.user.id }}"
									version="{{ entry.user.profileImageVersion }}"
								></stages-user-image>
							</div>
							<div class="text">
								<div class="info">
									<div class="wrapper">
										<p>
											<span class="user spacer highlight">{{ entry.user.fullname }}</span>
											<span class="spacer" translate="process.history.change.{{ entry.changeType }}"></span>
											<span [hidden]="!entry.label.length" class="highlight spacer">{{ entry.label }}</span>
										</p>
									</div>
									<span class="h6 date">{{ entry.date }}</span>
								</div>
								<p></p>
							</div>
						</div>
					</li>
					@if (showBubble($any(visibleEntries), allEntries, i) && isCollapsed) {
						<li class="list-item bubble">
							<a class="label" (click)="toggle()">
								<div class="avatar-cell">
									<div class="circle-icon">
										<i class="ico ico-more-horizontal"></i>
									</div>
								</div>
								<div class="text fullsize">
									<div class="info">
										<p class="clickable">
											<span translate="process.history.showall"></span>
											<span class="counter">{{ getNumberOfInvisibleEntries($any(visibleEntries), allEntries) }}</span>
										</p>
									</div>
								</div>
							</a>
						</li>
					}
					@if (!last) {
						<li class="divider"></li>
					}
				}
			}
		</ul>
	} @else {
		<p class="empty" translate="{{ translateNone }}"></p>
	}
</article>
